import { useId, type Ref } from "react";

import "./MatchMenu.css";

export type MatchMenuProps = Readonly<{
  onResume: () => void;
  onOpenRules: () => void;
  onOpenSettings: () => void;
  onOpenHistory: () => void;
  onRequestNewGame: () => void;
  newGameButtonRef?: Ref<HTMLButtonElement>;
  finished?: boolean;
  finishedReturnLabel?: "Return to result" | "Return to review";
}>;

/** In-match navigation only. Destructive actions are requests so the app can confirm them. */
export function MatchMenu({
  onResume,
  onOpenRules,
  onOpenSettings,
  onOpenHistory,
  onRequestNewGame,
  newGameButtonRef,
  finished = false,
  finishedReturnLabel = "Return to result",
}: MatchMenuProps) {
  const titleId = useId();

  return (
    <section className="match-menu" aria-labelledby={titleId}>
      <header className="match-menu__header">
        <h2 id={titleId}>Menu</h2>
      </header>

      <nav aria-label="Match menu" className="match-menu__actions">
        <button className="match-menu__primary" type="button" onClick={onResume}>
          {finished ? finishedReturnLabel : "Resume match"}
        </button>
        <button type="button" onClick={onOpenRules}>
          How to play
        </button>
        <button type="button" onClick={onOpenSettings}>
          Settings
        </button>
        <button type="button" data-history-action onClick={onOpenHistory}>
          History
        </button>
        {!finished ? (
          <button
            ref={newGameButtonRef}
            className="match-menu__danger"
            type="button"
            onClick={onRequestNewGame}
          >
            New game
          </button>
        ) : null}
      </nav>
    </section>
  );
}
